import { FormControlLabel, Radio } from "@mui/material"

/**
 * One selectable option inside a recipient `choice` field. Rendered per option via `<Repeat>` so we
 * avoid an inline closure component inside the `<BoundRadioGroup>`. The surrounding `BoundRadioGroup`
 * supplies the radio group's value/onChange; each option simply contributes a labelled `<Radio>`.
 *
 * @param {object} props
 * @param {string} props.option the option's value/label (requested-field options are plain strings)
 */
export function RequestedFieldChoiceOption({ option }) {
    return <FormControlLabel value={option} control={<Radio />} label={option} />
}
